@for (option of checkOptions; track $index; let i = $index) {
  <mat-checkbox
    [id]="id + '_' + i"
    [formlyAttributes]="field"
    [tabIndex]="props.tabindex"
    [checked]="isChecked(option)"
    [disabled]="formControl.disabled || isDisabled(option)"
    (change)="onChange(option.id, $event.checked)"
  >
    {{ option.text }}
    <div
      [classList]="`slid-tag slid-tag-${option.sensitivity_level_id}`"
      [title]="slids[option.sensitivity_level_id]"
      >{{ short_slids[option.sensitivity_level_id] }}</div
    >
  </mat-checkbox>
}
